import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Define a type for the slice state

// Define the initial state using that type

const getEmpTrainingSlice = createSlice({
  name: "Training",

  initialState: { empTrainingData: [], trainingLoader: false },
  reducers: {
    setEmpTrainingData: (state: any, action: PayloadAction<any>) => {
      console.log("ACTION @ EMP training--", action);
      state.empTrainingData = action.payload;
    },
    setTrainingLoader: (state: any, action: PayloadAction<any>) => {
      state.trainingLoader = action.payload;
    },
    resetEmpTrainingData: (state: any) => {
      state = [];
    },
  },
});

export const { setEmpTrainingData, resetEmpTrainingData, setTrainingLoader } =
  getEmpTrainingSlice.actions;

// // Other code such as selectors can use the imported `RootState` type
// export const selectCount = (state: RootState) => state.counter.value

export default getEmpTrainingSlice.reducer;
